// extracted by mini-css-extract-plugin
export default {"steps":"YmasrjWAu5un9rBwdO7O","step-content":"qTa2bPZzOG_TUD4JeOI1","type-icon":"g9n8L30yyeyEh5I4lSpy"};